interface ClientLogoProps {
  image: string;
  title: string;
  size?: 'sm' | 'md' | 'lg';
}

const ClientLogo = ({ image, title, size = 'md' }: ClientLogoProps) => {
  const sizeClasses = {
    sm: 'w-20 h-20 sm:w-24 sm:h-24',
    md: 'w-32 h-32 sm:w-40 sm:h-40',
    lg: 'w-40 h-40 sm:w-48 sm:h-48',
  };

  return (
    <div
      className={`flex-shrink-0 ${sizeClasses[size]} rounded-full bg-transparent flex items-center justify-center overflow-hidden`}
    >
      <img
        src={`/clients/${image}`}
        alt={title}
        className="w-full h-full object-contain"
        style={{ backgroundColor: 'transparent' }}
      />
    </div>
  );
};

export default ClientLogo;
